import { Component, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataGridStore } from '../../data-grid.store';

@Component({
    host: {
        ngSkipHydration: 'true',
    },
    selector: 'app-checkbox-column',
    standalone: true,
    template: `
        <div class="flex justify-center">
            <input
                [(ngModel)]="value"
                (ngModelChange)="valueChange($event)"
                type="checkbox"
                checked="checked"
                class="rounded checkbox-primary border-neutral-300 checkbox"
            />
        </div>
    `,
    imports: [FormsModule],
})
export class CheckboxColumn {
    readonly store = inject(DataGridStore);

    value = model<boolean>(false);
    selecteds = model<any[]>([]);

    /**
     * @description 전체 선택/해제
     * @param ev
     */
    valueChange(ev: boolean) {
        const rowData = this.store.rowData() || [];

        if (ev) {
            this.selecteds.set(rowData);
        } else {
            this.selecteds.set([]);
        }
    }
}
